<template>
<div class="viewport-wrap-box scollbar" :class="{'light': isLight}" id="container">
  <keep-alive>
    <router-view v-if="isShowDataAll" :sensorMeaInfo="sensorMeaInfo" :isLight="isLight" v-on:get-light="bool => isLight = bool"></router-view>
  </keep-alive>
  <!-- start message-tip -->
  <message-tip :is-show="isShowMessageTip" :message-text="messageTipText" :duration="messageTipDuration" :type="messageTipType" @off="offMessageTip" :is-show-close-btn="messageTipIsShowCloseBtn">
  </message-tip>
  <!-- end message-tip -->
</div>
</template>
<script>
// 引入微信js-sdk
import wx from "weixin-js-sdk";

import {
  ajax
} from "Services/ajax"
import utils from "Assets/js/utils"
import datajs from "Services/data"
import {
  mapActions,
  mapGetters
} from 'vuex'
import messageTip from 'Components/message-tip/message-tip'
export default {
  props: {},
  data() {
    return {
      isLight: utils.getOtherInfo(window.str + 'light' + utils.getUrlParam(window.location.href, '', 1)) && utils.getOtherInfo(window.str + 'light' + utils.getUrlParam(window.location.href, '', 1)) == 'true' ? true : false,
      isShowDataAll: false,  
    }
  },
  components: {
    messageTip
  },
  computed: {
    ...mapGetters({
      isShowMessageTip: 'isShowMessageTip', //是否显示messageTip
      messageTipText: 'messageTipText', //消息提示内容
      messageTipDuration: 'messageTipDuration', //messageTip动画持续时间
      messageTipType: 'messageTipType', // messageTip 图标提示类型
      messageTipIsShowCloseBtn: 'messageTipIsShowCloseBtn', // 是否显示messageTip关闭按钮
    })
  },
  methods: {
    ...mapActions({
      hideMessageTip: 'hideMessageTip'
    }),
    offMessageTip() {
      this.$store.dispatch('hideMessageTip')
    },
    // 读取json文件，获取测量类型、传感器类型翻译
    getSensorMeaInfo() {
      datajs.getJson("https://sensecap-statics.seeed.cn/refer/def/sensor.json").then(res => {
        if (res.status == 200) {
          this.sensorMeaInfo = null;
          this.sensorMeaInfo = res.data ? res.data : {};
        }
        this.isShowDataAll = true;
      }).catch(err => {
        this.isShowDataAll = true;
      })
    },
    getWxInfo() {
      let ua = navigator.userAgent.toLowerCase();
      //Ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (ua.indexOf('mobile') == -1) {
        return false;
      }
      const shref = window.location.href;
      const sinde = shref.indexOf('index/') != -1 ? shref.slice(shref.indexOf('index/') + 6) : null;
      const stit = sinde != null ? utils.getOtherInfo(window.str + 'sname' + sinde) : '气象站数据大屏';
      const slogo = sinde != null ? utils.getOtherInfo(window.str + 'slogo' + sinde) : 'https://sensecap-solution-upload.cdn.seeed.cn/cn/2020/04/banner-logo-1.png';
      const stext = sinde != null ? utils.getOtherInfo(window.str + 'stext' + sinde) : '由传感器、节点，网关等组成的智能环境监测系统，可以实时收集大气温湿度、二氧化碳、大气压、光照，土壤温湿度、EC值等数据并以图表清晰呈现。';
      if (!this.iswx) {
        const urlstr = shref.indexOf('#') != -1 ? shref.split('#')[0] : shref;
        ajax.getData(window.apiUrl.getJsConfig.url, {
          params: {
            url: urlstr
          }
        }).then(res => {
          if (res.code == 0) {
            if (sinde == 1) {
              window.alert(JSON.stringify(res.data))
            }
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.noncestr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名
              jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表
            });
            wx.ready(() => {
              // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）最新接口
              wx.updateAppMessageShareData({
                title: stit, // 分享标题
                desc: stext, // 分享描述
                link: urlstr, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: slogo, // 分享图标
                success: function() {
                  // 设置成功
                  if (sinde == 1) {
                    window.alert('success-ok')
                  }
                },
                fail: function(err) {
                  if (sinde == 1) {
                    window.alert(JSON.stringify(err))
                  }
                }
              });
              // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）最新接口
              wx.updateTimelineShareData({
                title: stit, // 分享标题
                desc: stext, // 分享描述
                link: urlstr, // 分享链接
                imgUrl: slogo, // 分享图标
                success: function() {
                  // 设置成功
                  if (sinde == 1) {
                    window.alert('success-ok')
                  }
                },
                fail: function(err) {
                  if (sinde == 1) {
                    window.alert(JSON.stringify(err))
                  }
                }
              });
            });
            wx.error(err => {
              if (sinde == 1) {
                window.alert(JSON.stringify(err))
              }
            });
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
  },
  created() {
    this.getSensorMeaInfo()
  },
  mounted() {
    $("#appLoading").hide();
    $("#app").show();
    console.log('2024-01-15 15:30');
  }
}
</script>
<style lang="scss">
.viewport-wrap-box {
    width: 100%;
    height: 100%;
    overflow: auto;
    font-size: 0;
    background: rgba(49, 48, 57, 1);
}

.viewport-wrap-box.light {
    background: rgba(248,250,255,1);
}
</style>
